module.exports = __webpack_public_path__ + "img/bounty_squad_small.bbf24733.png";